<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0">

    <div class="col-md-3">Report SSC</div>


    <div class="col-md-3">
      <ol class="breadcrumb cust-bread">
        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting()"><i
                class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Report SSC </li>
      </ol>
    </div>
  </div>
  <div class="col-md-12 padtop">
    <div class="card reportdiv">
      <div class="card-header row">
        <div class="col-md-4 reportdiv">
          <div class="form-group">
            <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1"
                   placeholder="From Date" [(ngModel)]="fromDate">
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
          </div>
        </div>
        <div class="col-md-4 reportdiv">
          <div class="form-group">
            <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2"
                   placeholder="To Date" [(ngModel)]="toDate">
            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
          </div>
        </div>
        <div class="col-md-2 reportdiv">
          <button class="btn btn-success addButton font-13 sub-btn" (click)="generate()">Generate Report</button>
        </div>
        <div class="col-md-2 reportdiv">
          <button class="btn btn-success addButton font-13 download-btn" (click)="getReportList()">Refresh Page</button>
        </div>
        <!--<a href={{reportLink}} [hidden] = 'hidereport' class="downloadlink">Click here for download report</a>-->
          <!--<div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>-->
      </div>
    </div>
  </div>
  <div class="col-md-12 padtop">
    <div class="card reportdiv">
      <div class="card-header row">
        <div class="loader" [hidden]="reportLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">Report File Name</th>
            <th scope="col">Report Generated Date</th>
            <th scope="col">From Date</th>
            <th scope="col">To Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let file of reportFiles">
            <td><a class="pointer" (click)="downloadFile(file.document_nm)">{{file.document_nm}}</a></td>
            <td>{{file.createdate}}</td>
            <td>{{file.fromdt}}</td>
            <td>{{file.todt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>